import DOMPurify from 'dompurify'
import React, { useMemo } from 'react'

/**
 * 저장된 HTML을 sanitize 후 렌더링 (운영자 공지 등).
 */
export default function SanitizedRichText({ html, className }) {
  const safe = useMemo(
    () =>
      DOMPurify.sanitize(html || '', {
        USE_PROFILES: { html: true },
        ADD_ATTR: ['style', 'class', 'target', 'rel', 'colspan', 'rowspan'],
      }),
    [html]
  )

  return (
    <div
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  )
}
